import type { Option } from "@tento-lona/sheets";
import { LiveData } from "@tento-core/livedata";
import { DateTime, Utc } from "@tento-chrono";
import type { FeatureFlag } from "@tento-lona";

/**
 * The calendar column's one current-time clock — a `time` signal ticked once a
 * minute (or every simulated minute at 1s under the `fastCurrentTime` debug
 * flag). The timed grid reads it for the "now" marker (`--current-time-mse`)
 * and its column signals; nothing else needs it, so the layout plugin owns one
 * and disposes it.
 */
export class CurrentTimeClock {
  readonly time: LiveData<DateTime<Utc>>;
  #interval: Option<ReturnType<typeof setInterval>> = null;

  constructor(fast: FeatureFlag) {
    let curr = Utc.now();
    this.time = new LiveData(curr);
    fast.addListener(
      this,
      (fastTime) => {
        if (this.#interval != null) clearInterval(this.#interval);
        if (fastTime) {
          this.#interval = setInterval(() => {
            curr = curr.add({ mins: 1 });
            this.time.update(curr);
          }, 1_000);
        } else {
          this.time.update(Utc.now());
          this.#interval = setInterval(() => {
            this.time.update(Utc.now());
          }, 60_000);
        }
      },
      LiveData.TriggerImmediately,
    );
  }

  dispose(): void {
    if (this.#interval != null) clearInterval(this.#interval);
    this.#interval = null;
  }
}
